import {Controller, useFormContext} from "react-hook-form";
import {Divider, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {TextFieldWithEnterHandling} from "./TextFieldWithEnterHandling";
import React from "react";

export function MuiRhfStringListField(props: {
  /**
   * The name of the field in the RHF Form in which the string list should be saved
   */
  name: string,
  /**
   * The label to be shown on the input field for new entries
   */
  inputLabel: string,
  /**
   * The title shown on top of the list
   */
  title?: string,
  /**
   * Called if a submit was pressed without inserting anything into the input field. This could be handled as global return, ending the current editing.
   */
  handleEmptySubmit?: () => void,
  disabled?: boolean,
}) {
  const {control} = useFormContext<any>();

  return (
    <Controller
      name={props.name}
      control={control}
      render={renderProps => {
        let list = renderProps.field.value as string[] || [];
        return <>
          <List
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                {props.title}
              </ListSubheader>
            }
          >
            {list.map((item, index) =>
              <React.Fragment key={index}>
                <ListItem key={index}>
                  <ListItemText primary={item}/>
                  <ListItemSecondaryAction>
                    <IconButton
                      disabled={props.disabled}
                      edge="end"
                      aria-label="delete"
                      onClick={() => {
                        list.splice(index, 1);
                        renderProps.field.onChange(list);
                      }}
                      size="large">
                      <DeleteIcon/>
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider variant="fullWidth" component="li" key={"div_" + index}/>
              </React.Fragment>
            )}
          </List>
          {!props.disabled &&
            <TextFieldWithEnterHandling label={props.inputLabel} onSubmit={(value) => {
              if (value === '' && props.handleEmptySubmit) {
                props.handleEmptySubmit();
              } else {
                renderProps.field.onChange(list.concat(value));
              }
            }}/>
          }
        </>;
      }}/>
  );
}
